/**
 * MechaGuard - RailgunTower (电磁轨道炮)
 *
 * 攻击方式：沿直线发射超高速穿甲弹，可贯穿多个敌人。
 * 定位：射程最远、单体伤害最高的重炮，专门克制高护甲单位
 *       （无视 40% 护甲），代价是射速慢、转向慢。
 * 满级特性：穿透数提升。
 */

import { Tower } from '../entities/Tower.js';

export class RailgunTower extends Tower {
  static META = {
    id: 'railgun',
    name: '电磁炮',
    icon: '🎯',
    cost: 250,
    desc: '超远射程，穿甲贯穿',
    color: '#ff3366',
    stats: {
      baseRange: 196,
      baseDamage: 88,
      fireInterval: 1.6,   // ≈ 55 DPS
      barrelLength: 24,
      turnSpeed: 5,
      firingFx: 0.22,
      projectileSpeed: 1400,
      penetrate: 2,           // 额外穿透目标数
      ignoreArmor: 0.4,       // 无视 40% 护甲
      penetrateBonus: 2,      // 满级额外穿透数
      aimTolerance: 0.12,     // 对准误差阈值（弧度），小于该值才开火
      maxDistanceMul: 1.6,    // 弹道最大长度 = 射程 * 该值
    },
  };

  constructor(col, row) {
    super(col, row);
  }

  get effectivePenetrate() {
    return this.level >= 3 ? this.penetrate + this.penetrateBonus : this.penetrate;
  }

  update(dt, game) {
    this.tickTimers(dt);

    const target = this.findTarget(game.enemies);
    this.target = target;

    if (!target) return;

    // 重炮转向慢
    const diff = this.aimAt(target, dt, this.turnSpeed);

    if (this.cooldown > 0) return;

    // 未对准时继续等待（冷却保持 <= 0，对准后立即开火）
    if (Math.abs(diff) > this.aimTolerance) return;

    this.cooldown = this.fireInterval;
    this.firing = this.firingFx;
    game.sfx('railgun');

    const mx = this.x + Math.cos(this.angle) * this.barrelLength;
    const my = this.y + Math.sin(this.angle) * this.barrelLength;

    game.spawnProjectile({
      mode: 'linear',
      x: mx,
      y: my,
      angle: this.angle,
      source: this,
      speed: this.projectileSpeed,
      damage: this.damage,
      ignoreArmor: this.ignoreArmor,
      pierce: this.effectivePenetrate,
      maxDistance: this.range * this.maxDistanceMul,
      color: this.color,
      size: 3.5,
      trail: true,
    });

    game.particles.spawnMuzzle(mx, my, this.angle, this.color);
    game.effects.addBeam(
      mx, my,
      mx + Math.cos(this.angle) * 26,
      my + Math.sin(this.angle) * 26,
      this.color, 0.12
    );
  }

  drawTurret(ctx, accent) {
    // 双轨电磁加速器
    ctx.fillStyle = 'rgba(10, 24, 42, 0.92)';
    ctx.strokeStyle = accent;
    ctx.lineWidth = 2;

    // 底座
    ctx.beginPath();
    ctx.rect(-11, -9, 12, 18);
    ctx.fill();
    ctx.stroke();

    // 上轨道
    ctx.beginPath();
    ctx.rect(0, -7, 26, 4);
    ctx.fill();
    ctx.stroke();

    // 下轨道
    ctx.beginPath();
    ctx.rect(0, 3, 26, 4);
    ctx.fill();
    ctx.stroke();

    // 能量导轨
    ctx.shadowColor = accent;
    ctx.shadowBlur = 10;
    ctx.fillStyle = accent;
    ctx.fillRect(2, -1.5, 22, 3);
    ctx.shadowBlur = 0;
  }
}
